<template>
  <div class="h-full sm:h-auto flex flex-col relative w-full">
    <Swiper
      class="
        bg-gradient-to-b
        from-white
        w-full
        h-52
        sm:h-96
        border-b
        shadow-inner
        border-bnb-mustard2
      "
      :space-between="20"
      :autoplay="{
        delay: 2500,
        disableOnInteraction: false,
        reverseDirection: false,
      }"
      direction="vertical"
      :loop="true"
      :speed="2000"
      :pagination="{
        clickable: false,
        type: 'progressbar',
        progressbarOpposite: false,
      }"
    >
      <SwiperSlide
        class="h-full w-full"
        v-for="banner in banners"
        :key="banner"
      >
        <img alt="image" class="w-full h-full object-contain" :src="banner" />
      </SwiperSlide>
    </Swiper>
    <p
      class="
        fixed
        bottom-0
        guttermarginbottom
        inset-x-0
        text-gray-600
        font-semibold
        text-sm
        mx-auto
      "
    >
      &copy; 2021 Buns & Batter Ltd
    </p>
    <!-- header -->
    <div class="flex relative justify-center items-center p-1 mb-2">
      <div class="absolute right-4 font-semibold">
        <p
          v-if="platform == 'web'"
          @click="installApp"
          class="
            text-sm
            px-2
            py-0.5
            active:bg-bnb-brown
            rounded-full
            border-white
            shadow-sm
            border
            bg-bnb-mustard
            text-white
          "
        >
          Install App
        </p>
        <p v-else-if="version" class="text-xs">v{{ version }}</p>
      </div>
      <img
        alt="image"
        class="h-12 shadow-inner bg-gray-50 border-t px-2"
        src="@/assets/logofullblack.png"
      />
    </div>
    <div class="relative flex-1 overflow-auto mx-4 py-4 space-y-6 pb-40">
      <ShareDownload />
      <OneClickConnect />
      <KneadAnything />
      <OpeningHours />
    </div>
    <div class="fixed z-50 w-full bottom-12 inset-x-0 md:px-48">
      <p
        @click="enterApp"
        class="
          animate-bounce
          bg-bnb-mustard
          py-1
          shadow-md
          mx-auto
          active:bg-bnb-brown
          border-white
          font-black
          text-white text-3xl
          rounded-xl
          w-2/3
        "
      >
        LET'S EAT
      </p>
    </div>
  </div>
</template>
<script>
import { App } from "@capacitor/app";
import { Device } from "@capacitor/device";
import OneClickConnect from "@/views/lounge/OneClickConnect";
import ShareDownload from "@/views/lounge/ShareDownload";
import KneadAnything from "@/views/lounge/KneadAnything";
import OpeningHours from "@/views/lounge/OpeningHours";
import "swiper/swiper.scss";
import "swiper/components/pagination/pagination.scss";
import "swiper/components/scrollbar/scrollbar.scss";
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Autoplay, Pagination, Scrollbar } from "swiper";
SwiperCore.use([Autoplay, Pagination, Scrollbar]);

export default {
  components: {
    Swiper,
    SwiperSlide,
    ShareDownload,
    OneClickConnect,
    KneadAnything,
    OpeningHours,
  },
  created() {
    Device.getInfo().then((infoObject) => {
      var platform = infoObject.platform;
      this.platform = platform;
      if (platform != "web") {
        App.getInfo().then((app) => {
          this.version = app.version;
        });
      }
    });
  },
  data() {
    return {
      version: "",
      platform: "",
      banners: [
        // "/img/intro/browsemenu.jpg",
        "/img/intro/placeorder.jpg",
        "/img/intro/wedeliver.jpg",
        "/img/intro/chatwithus.jpg",
      ],
    };
  },
  methods: {
    enterApp() {
      this.$router.push({ name: "MainApp" });
    },

    installApp() {
      Device.getInfo().then((device) => {
        if (device.operatingSystem == "ios") {
          location.href = this.$store.state.appDetails?.update?.iosLink;
        } else if (device.operatingSystem == "android") {
          location.href = this.$store.state.appDetails?.update?.androidLink;
        }
      });
    },
  },
};
</script>
